import {
  CHECK_IN_FULFILLED,
  CHECK_IN_PENDING,
  CHECK_IN_REJECTED,
  FETCH_WORK_SESSIONS_FULFILLED,
  FETCH_WORK_SESSIONS_PENDING,
  FETCH_WORK_SESSIONS_REJECTED,
  FETCH_WORK_SESSIONS_TABLE_FULFILLED,
  FETCH_WORK_SESSIONS_TABLE_PENDING,
  FETCH_WORK_SESSIONS_TABLE_REJECTED
} from '../actions/work-sessions';
import type { WorkSession, WorkSessionsState } from '../../types';

const initialState: WorkSessionsState = {
  byId: {},
  allIds: [],
  loading: false,
  error: null,
  tableUsers: [],
  tableSessionsByUser: {},
  tableStatisticsByDay: [],
  tableStatisticsByUser: [],
  tableLateStatisticsByUser: [],
  tableLoading: false
};

const workSessionsReducer = (state = initialState, action: any): WorkSessionsState => {
  switch (action.type) {
    case CHECK_IN_PENDING:
    case FETCH_WORK_SESSIONS_PENDING:
    case FETCH_WORK_SESSIONS_TABLE_PENDING:
      return {
        ...state,
        tableLoading: true,
        error: null
      };

    case CHECK_IN_FULFILLED: {
      const workSession = action.payload.data;

      return {
        ...state,
        byId: {
          ...state.byId,
          [workSession.id]: workSession
        },
        allIds: state.allIds.includes(workSession.id)
          ? state.allIds
          : [...state.allIds, workSession.id],
        loading: false,
        error: null
      };
    }

    case FETCH_WORK_SESSIONS_FULFILLED: {
      const workSessions = action.payload.data;
      const byId: { [key: number]: WorkSession } = {};
      const allIds: number[] = [];

      workSessions.forEach((ws: WorkSession) => {
        byId[ws.id] = ws;
        allIds.push(ws.id);
      });

      return {
        ...state,
        byId,
        allIds,
        loading: false,
        error: null
      };
    }

    case FETCH_WORK_SESSIONS_TABLE_FULFILLED: {
      const { users, workSessionsByUser, statisticsByUser, statisticsByDay, lateStatisticsByUser } = action.payload.data;

      return {
        ...state,
        tableUsers: users || [],
        tableSessionsByUser: workSessionsByUser || {},
        tableStatisticsByDay: statisticsByDay || [],
        tableStatisticsByUser: statisticsByUser || [],
        tableLateStatisticsByUser: lateStatisticsByUser || [],
        tableLoading: false,
        error: null
      };
    }

    case CHECK_IN_REJECTED:
    case FETCH_WORK_SESSIONS_REJECTED:
    case FETCH_WORK_SESSIONS_TABLE_REJECTED:
      return {
        ...state,
        tableLoading: false,
        error: action.payload?.response?.data?.error || 'An error occurred'
      };

    default:
      return state;
  }
};

export default workSessionsReducer;